import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/standard-button';
import { useFlags } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives';
import { G300 } from '@atlaskit/theme/colors';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { useInProductHelp, usePfErrorUtils } from '@atlassian/proforma-common-core/jira-common-context';
import { TicketType } from '@atlassian/proforma-common-core/jira-common-models';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { groupRequestTypes } from '../../../../../../common/utils/ticket-types';
import { useProjectFormsControllerActions } from '../../../../../../controllers';
import { useProjectFormApi } from '../../../../../../services/project-form-api';
import { messages } from './messages';
import { ModalTitleContainer, RequestTypeIcon, RequestTypeSpan } from './styled';
export const DeleteProjectFormModal = ({
  isServiceProject,
  form,
  onClose
}) => {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const {
    showFlag
  } = useFlags();
  const {
    onOpenInProductHelpArticle
  } = useInProductHelp();
  const {
    reportError
  } = usePfErrorUtils();
  const [, {
    load
  }] = useProjectFormsControllerActions();
  const projectFormApi = useProjectFormApi();
  const uniqueRequestTypes = Object.values(groupRequestTypes(form.requesttypes)).map(([firstRequestType]) => firstRequestType);
  const typeFilter = isServiceProject ? t => t.type === TicketType.RequestType : t => t.type === TicketType.IssueType;
  const types = uniqueRequestTypes.filter(typeFilter);
  const handleDeleteForm = () => {
    projectFormApi.deleteProjectForm(form.id).then(() => {
      showFlag({
        id: 'delete-form-success-flag',
        icon: /*#__PURE__*/React.createElement(SuccessIcon, {
          label: "Success",
          primaryColor: `var(--ds-icon-success, ${G300})`
        }),
        title: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.deleteFormSuccessFlagTitle, {
          values: {
            formName: form.name
          }
        })),
        isAutoDismiss: true
      });
      if (fg('proforma_add_project_form_analytics')) {
        fireTrackAnalytics(createAnalyticsEvent({}), `${ActionSubject.FORM} ${Action.DELETED}`, {
          templateFormId: form.id,
          projectId: form.projectId
        });
      }
      load();
      onClose();
    }).catch(error => {
      if (fg('proforma_add_project_form_analytics')) {
        reportError(error, {
          id: 'deleteForm'
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitleContainer, null, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: "warning"
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.heading, {
    values: {
      formName: form.name
    }
  }))))), /*#__PURE__*/React.createElement(ModalBody, null, uniqueRequestTypes.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FormattedMessage, isServiceProject ? messages.willRemoveRequestTypesMsg : messages.willRemoveIssueTypesMsg)), /*#__PURE__*/React.createElement("ul", null, types.map(requestType => /*#__PURE__*/React.createElement("li", {
    key: requestType.id
  }, /*#__PURE__*/React.createElement(RequestTypeSpan, null, /*#__PURE__*/React.createElement(RequestTypeIcon, {
    src: requestType.iconUrl
  }), requestType.name)))), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, /*#__PURE__*/React.createElement(FormattedMessage, isServiceProject ? messages.futureRequestMessage : messages.futureIssueMessage))), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.affectExistingIssues), "\xA0", /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    spacing: "none",
    onClick: () => onOpenInProductHelpArticle('2WUi6sHHMAhNDpaw0seJlj')
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.learnMoreLink)))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "default",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.cancel)), /*#__PURE__*/React.createElement(Button, {
    appearance: "warning",
    onClick: handleDeleteForm
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.delete))));
};